// Pure helpers for the Event Correspondence tab (filtering, counts, link type, snippets).

export var UNCATEGORIZED_KEY = '__uncategorized__'

// Mirrors Correspondence.vue (linkType 0 = auto, 1 = manual), also accepting 'Auto' / 'Manual' strings.
export function isAutoLinked (item) {
  if (!item) {
    return false
  }
  return item.linkType === 0 || (typeof item.linkType === 'string' && item.linkType.toLowerCase() === 'auto')
}

export function isManualLinked (item) {
  if (!item) {
    return false
  }
  return item.linkType === 1 || (typeof item.linkType === 'string' && item.linkType.toLowerCase() === 'manual')
}

export function hasCategory (item) {
  return item.categoryId !== null && item.categoryId !== undefined && item.categoryId !== ''
}

export function applyResolvedFilter (items, hideResolved) {
  var list = items || []
  if (!hideResolved) {
    return list.slice()
  }
  return list.filter(function (item) {
    return item.resolved !== true
  })
}

export function matchesCategories (item, selectedCategoryKeys) {
  if (!selectedCategoryKeys || selectedCategoryKeys.length === 0) {
    return true
  }
  var key = hasCategory(item) ? item.categoryId : UNCATEGORIZED_KEY
  return selectedCategoryKeys.indexOf(key) !== -1
}

export function filterItems (items, selectedCategoryKeys, hideResolved) {
  return applyResolvedFilter(items, hideResolved).filter(function (item) {
    return matchesCategories(item, selectedCategoryKeys)
  })
}

// Returns { total, byCategory: { [categoryId]: n }, uncategorized, hasUncategorized }
// computed from items after the resolved filter only (ignores category selection).
export function computeCategoryCounts (items, hideResolved) {
  var visible = applyResolvedFilter(items, hideResolved)
  var byCategory = {}
  var uncategorized = 0
  visible.forEach(function (item) {
    if (hasCategory(item)) {
      byCategory[item.categoryId] = (byCategory[item.categoryId] || 0) + 1
    } else {
      uncategorized = uncategorized + 1
    }
  })
  var hasUncategorized = uncategorized > 0
  return {
    total: visible.length,
    byCategory: byCategory,
    uncategorized: uncategorized,
    hasUncategorized: hasUncategorized
  }
}

export function makeSnippet (body, maxLength) {
  if (!body) {
    return ''
  }
  var limit = maxLength || 160
  var text = String(body).replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim()
  if (text.length > limit) {
    return text.substring(0, limit) + '...'
  }
  return text
}

// Tab order in EventManage.vue: Details, People, Documentation, [Correspondence], Expenses, [Claim], Activity
export function eventManageTabIndex (key, permissions) {
  var perms = permissions || {}
  var tabs = ['details', 'people', 'documentation']
  if (perms.viewCorrespondence) {
    tabs.push('correspondence')
  }
  tabs.push('expenses')
  if (perms.manageInsuranceClaims) {
    tabs.push('claim')
  }
  tabs.push('activity')
  return tabs.indexOf(key)
}
